module.exports = __webpack_public_path__ + "img/lastName.522cf2da.svg";